import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import messages from "./module/messages";
import { IExitModalProps } from "./module/constants";

// Import style
import classes from "./ExitModal.module.scss";

const ExitModal = (props: IExitModalProps) => {
  return (
    <>
      <Modal
        show={props.show}
        size="sm"
        onHide={props.onClose}
        centered
        contentClassName={classes.content}
      >
        <Modal.Header className={classes.header}>
          <Modal.Title style={{ fontSize: "1rem" }}>
            <FormattedMessage {...messages.title} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "0.75rem" }}>
          <FormattedMessage {...messages.content} />
        </Modal.Body>
        <Modal.Footer className={classes.footer}>
          <button
            className={`${classes.btn} ${classes["btn-cancel"]}`}
            onClick={props.onClose}
          >
            <FormattedMessage {...messages.cancel} />
          </button>
          <button
            className={`${classes.btn} ${classes["btn-confirm"]}`}
            onClick={props.onConfirm}
          >
            <FormattedMessage {...messages.confirm} />
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ExitModal;
